import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseHeader() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات هدر را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetHeader = (HeaderId, callback) => {
    MyAxios.get(`Admin_HomePage/GetHeader/${HeaderId}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const SetHeader = (state, logo1, logo2, logo3, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (logo1) {
      data.append("logo1", logo1);
    }
    if (logo2) {
      data.append("logo2", logo2);
    }
    if (logo3) {
      data.append("logo3", logo3);
    }
    MyAxios.post(`Admin_HomePage/SetHeader`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محتوای هدر با موفقیت تنظیم شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const SetHeaderTopBanner = (state, banner1, banner2, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));

    if (banner1) {
      data.append("banner1", banner1);
    }
    if (banner2) {
      data.append("banner2", banner2);
    }
    MyAxios.post(`Admin_HomePage/SetHeaderTopBanner`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محتوای هدر با موفقیت تنظیم شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const RemoveHeaderTopBanner = (ID, callback) => {
    const data = new FormData();
    data.append("Id", ID);
    MyAxios.delete(`Admin_HomePage/RemoveHeaderTopBanner`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("باموفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    validate,
    GetHeader,
    SetHeader,
    SetHeaderTopBanner,
    RemoveHeaderTopBanner,
  };
}
